import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { useGhgComparisons } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/real-world-units-comparisons/ghg';

export function useRealWorldComparison() {
  const context = useNetImpactLensContext();
  const ghgComparisons = useGhgComparisons();
  const selection = context?.state;
  if (!selection) {
    return [];
  }
  const impact = selection.impact;
  if (impact === ImpactCategoryId.GHG_EMISSIONS) {
    return ghgComparisons;
  }
  return [];
}
